import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Mobile16 = ({
  height = 16,
  width = 16,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="-1 0 16 16" {...props}>
    <path
      d="M9.1875 1.4375H4.8125C3.846 1.4375 3.0625 2.221 3.0625 3.1875V12.8125C3.0625 13.779 3.846 14.5625 4.8125 14.5625H9.1875C10.154 14.5625 10.9375 13.779 10.9375 12.8125V3.1875C10.9375 2.221 10.154 1.4375 9.1875 1.4375Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.0625 11.3541H10.9375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
